<template>
  <div class="notice-detail">
    <div class="main" v-if="obj.id">
      <div class="head-container">
        <div class="title" :class="{ zuofei: obj.status == 3 }">
          {{ obj.title }}
          <template v-if="obj.status == 3">-已作废</template>
        </div>
        <div class="desc">
          {{ obj.createTime | formatDatetime('yyyy-MM-dd hh:mm') }}
        </div>
        <div class="desc" v-if="obj.receiverRange == 1">
          {{obj.campusList && obj.campusList.map(item=>item.name).join("、")}}
        </div>
        <div class="desc">发送老师：{{ obj.operatorName }}</div>
        <div class="desc">
          {{ obj.isNeedConfirm ? '已确认' : '已读' }}：{{
            obj.isNeedConfirm ? obj.confirmCount : obj.readCount
          }}/{{ obj.studentCount }}
          <span class="tlc" @click="gotoReceive">查看详情</span>
        </div>
      </div>
      <div class="content">
        <vx-mult-input-show :list="obj.content.list"></vx-mult-input-show>
      </div>
    </div>

    <page-footer-btn
      multipleBtns
      v-if="
        obj.id &&
        ((obj.status !== 3 && app.permission.op('destroy_notice_task')) ||
          app.permission.op('send_notice_task'))
      "
    >
      <van-button
        square round
        block
        @click="zuofei"
        v-if="obj.status !== 3 && app.permission.op('destroy_notice_task')"
        >作废</van-button
      >
      <van-button
        square round
        block
        type="primary"
        @click="copy"
        v-if="app.permission.op('send_notice_task')"
        >复制通知</van-button
      >
    </page-footer-btn>
    <empty-page :show="isDeleted" tips="已被机构删除"> </empty-page>
  </div>
</template>

<script>
import emptyPage from '@teacher/components/empty-page.vue';
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';
export default {
  name: 'notice-detail',
  data() {
    return {
      pageTitle: '通知详情',
      isDeleted: false,
      obj: {},
    };
  },
  computed: {},
  components: {
    emptyPage,
    pageFooterBtn,
  },
  created() {
    let { id } = this.$route.params;
    this.$api.noticeInfo(id).then(res => {
      if (res.code == 200) {
        this.obj = res.data;
      } else if (res.code == 830000404) {
        this.isDeleted = true;
      }
    });
  },
  methods: {
    async zuofei() {
      await this.$dialog.confirm({
        title: '提示',
        message: '作废此条通知后，家长端将无法查看该通知。确定要作废吗？',
        confirmButtonText: '确定',
        confirmButtonColor: 'var(--c3)',
        cancelButtonText: '取消',
      });
      await this.$api.destroy({
        noticeTaskId: this.obj.id,
      });
      this.$toast('已作废此通知');
      app.vue.$emit('refresh-notice-list');
      this.obj.status = 3;
    },
    copy() {
      let clone = JSON.parse(JSON.stringify(this.obj));
      clone.campusList = [];
      clone.studentList = [];
      this.$router.replace({
        name: 'notice-add',
        params: clone,
      });
    },
    gotoReceive() {
      this.$router.push(`/notice-receive/${this.obj.id}?isNeedConfirm=${this.obj.isNeedConfirm}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.notice-detail {
  height: 100%;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1 1 auto;
    background: var(--white);
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
    overflow-y: auto;
    .head-container {
      margin-bottom: calc(var(--gap) * 25);
      .title {
        font-size: var(--fs-ex2);
        line-height: var(--lh-ex2);
        color: var(--g8);
        margin-bottom: calc(var(--gap) * 8);
        &.zuofei {
          color: var(--g5);
        }
      }
      .desc {
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        color: var(--g6);
        .tlc {
          margin-left: calc(var(--gap) * 8);
          color: var(--tlc);
        }
      }
    }
  }
}
</style>

